import {useEffect, useMemo} from "react";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function CloneList({ data }) {
    const cloneListData = useMemo(() => {
        const source = data?.cloneList || [];

        return {
            labels: [
                "ID",
                "Placa",
                "Data da notificação",
                "Verificado por",
                "Data da assinatura",
                "Data da verificação",
                "ID da ocorrência",
                "Município 1",
                "Município 2",
            ],
            values: source.map(item => [
                item.id ?? "Não informado",
                item.plate ?? "Não informado",
                item.date_notification ?? "Não informado",
                item.user_verification ?? "Não verificado",
                item.date_sign ?? "-",
                item.verification_time ?? "-",
                item.occ_id ?? "-",
                item.cityname1 ?? "Não informado",
                item.cityname2 ?? "Não informado",
            ]),
        };
    }, [data]);

    useEffect(() => {
        if (!cloneListData.values.length) return;

        ReportUtils.createExportableTable(
            cloneListData.labels,
            cloneListData.values,
            "Lista de clones",
        );
    }, [cloneListData]);
}